import axios from "axios";

const GeoserverApi = axios.create({
  baseURL: "http://geoserver.fjp.mg.gov.br/rest/",
  
});

export default GeoserverApi;